module.exports = __webpack_public_path__ + "static/google-play-71c02a81b5e75669e9c92912bb59a99c.png";